import { useMemo, useState } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import useContactLists from '@/hooks/useContactLists';
import { IContact, IContactList } from '@/types';
import axiosClient from '@/utils/axiosClient';
import DataTable from '../DataTable/DataTable';
import { Switch } from '../ui/switch';

interface ContactListAssociationsProps {
  contact: IContact;
}

const ContactListAssociations = ({ contact }: ContactListAssociationsProps) => {
  const model = useContactLists();
  const data = useMemo(() => model.data || [], [model.data]);

  const [list, setList] = useState<IContactList[]>(contact.contact_lists || []);

  async function toggle(contactList: IContactList) {
    try {
      const response = await axiosClient.post(`v1/contact_lists/${contactList.id}/toggle_contact`, {
        contact_id: contact.id,
      });
      if (response.status === 200) {
        setList((prev) => {
          const isInList = prev.some((item) => item.id === contactList.id);
          if (isInList) {
            return prev.filter((item) => item.id !== contactList.id);
          }
          return [...prev, contactList];
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  const columns: ColumnDef<IContactList>[] = [
    {
      accessorKey: 'name',
      header: 'Contact List',
    },
    {
      accessorKey: 'description',
      header: '',
    },
    {
      id: 'subscribed',
      header: 'Subscribed',
      cell: ({ row }) => (
        <Switch
          checked={list.some((item) => item.id === row.original.id)}
          onCheckedChange={() => {
            toggle(row.original as IContactList);
          }}
        />
      ),
    },
  ];

  return <DataTable data={data} columns={columns} model={model} placeholder="Search for contact lists..." />;
};

export default ContactListAssociations;
